import React, { useState } from "react";

const SportsSidebar = ({ isOpen, onClose }) => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (path) => {
    setOpenItems((prev) => ({
      ...prev,
      [path]: !prev[path],
    }));
  };

  if (!isOpen) return null;

  const sportsData = [
    {
      name: "Football",
      children: [
        {
          name: "ALGERIA Ligue 1",
          children: [
            {
              name: "2026-02-13",
              children: [
                { name: "CS Constantine v ES Setif" },
                { name: "MC El Bayadh v ASO Chlef" },
              ],
            },
          ],
        },
        { name: "ARGENTINA Primera B" },
        { name: "ARGENTINA Liga Profesional" },
        { name: "AUSTRALIA A-League" },
      ],
    },
    {
      name: "Tennis",
      children: [
        { name: "ATP DALLAS OPEN 2026" },
        { name: "ATP ROTTERDAM OPEN 2026" },
      ],
    },
  ];

  const renderTree = (items, parentPath = "", level = 0) => {
    return items.map((item, index) => {
      const currentPath = parentPath + index;
      const isOpen = openItems[currentPath];
      const hasChildren = item.children && item.children.length > 0;

      return (
        <div key={currentPath} className="tree-wrapper">
          <div
            className="tree-row"
            style={{ marginLeft: level * 22 }}
            onClick={() => hasChildren && toggleItem(currentPath)}
          >
            {level !== 0 && (
              <div className="line-column">
                <div className="vertical-line"></div>
                <div className="dot"></div>
              </div>
            )}

            <div className="label">
              {hasChildren ? (
                <>
                  {item.name}
                  <span className="symbol">{isOpen ? " -" : " +"}</span>
                </>
              ) : (
                <a href="#" className="leaf-link">
                  {item.name}
                </a>
              )}
            </div>
          </div>

          {isOpen &&
            hasChildren &&
            renderTree(item.children, currentPath + "-", level + 1)}
        </div>
      );
    });
  };

  return (
    <>
      <style>{`
        .sports-sidebar {
          position: absolute;
          width: 275px;
          height: 100vh;
          background: #f9f9f9;
          padding: 20px 15px;
          overflow-y: auto;
          font-family: Arial, sans-serif;
          box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
          z-index: 9;
          color: #000;
        }

        .sports-sidebar .sidebar-header {
          display: flex;
          justify-content: space-between;
          font-size: 20px;
          font-weight: 500;
          margin-bottom: 15px;
        }

        .sports-sidebar .tree-row {
          display: flex;
          align-items: center;
          cursor: pointer;
          margin: 8px 0;
        }

        .sports-sidebar .line-column {
          position: relative;
          width: 20px;
          display: flex;
          justify-content: center;
        }

        .sports-sidebar .vertical-line {
          position: absolute;
          left: 9px;
          top: -10px;
          bottom: -10px;
          width: 1px;
          background: black;
        }

        .sports-sidebar .dot {
          width: 10px;
          height: 10px;
          background: #3b82f6;
          border-radius: 50%;
          position: relative;
          z-index: 2;
        }

        .sports-sidebar .label {
          font-size: 12px;
          margin-left: 8px;
          font-weight: 500;
        }

        .sports-sidebar .symbol {
          font-weight: bold;
          margin-left: 6px;
        }

        .sports-sidebar .closeBtn {
          cursor: pointer;
          font-size: 18px;
          font-weight: bold;
        }

        .sports-sidebar .leaf-link {
            text-decoration: none;
            color: #000;
        }

      `}</style>

      <div className="sports-sidebar">
        <div className="sidebar-header">
          <span>Sports</span>
          <span className="closeBtn" onClick={onClose}>
            ✕
          </span>
        </div>

        {renderTree(sportsData)}
      </div>
    </>
  );
};

export default SportsSidebar;
